<div class="flex-vertical gap-32">
  <app-montant-operation
    [touchNonce]="touchNonce"
    (onSpecificDataChanged)="onDataChange($event)"
    [initialData]="initialData"
    [isRequired]="true"></app-montant-operation>
  <app-type-signature-partenaire
    [touchNonce]="touchNonce"
    [operation]="operation"
    (onSpecificDataChanged)="onDataChange($event)"
    [initialData]="initialData"></app-type-signature-partenaire>
  <app-type-taux-frais
    [touchNonce]="touchNonce"
    (onSpecificDataChanged)="onDataChange($event)"
    [initialData]="initialData"></app-type-taux-frais>
  <app-fonds-evenementiels
    (onSpecificDataChanged)="onDataChange($event)"
    [operationIndex]="operationIndex"
    [initialData]="initialData"></app-fonds-evenementiels>
  <app-specific-comment
    (onSpecificDataChanged)="onDataChange($event)"
    [initialData]="initialData"></app-specific-comment>
</div>
